/** MM/DD/YYYY for a date (`2026-04-02`) or a UTC timestamp (`2026-04-02T16:20:00Z`). Date-only values are never shifted by a time zone. */
export function formatDisplayDate(value: string | null | undefined): string {
  if (!value) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!m) return value;
  if (value.length === 10) return `${m[2]}/${m[3]}/${m[1]}`;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return `${m[2]}/${m[3]}/${m[1]}`;
  return `${String(d.getUTCMonth() + 1).padStart(2, '0')}/${String(d.getUTCDate()).padStart(2, '0')}/${d.getUTCFullYear()}`;
}
